import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";


const JobRequests = lazy(() => import("../pages/JobRequests"));

export const jobRequestsRoutes = [
  {
    path: "/job-requests",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <JobRequests />
      </Suspense>
    ),
  },
];
